import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: "idle", // idle, order_type, menu, checkout, confirmation
};

const stepSlice = createSlice({
    name: "step",
    initialState,
    reducers: {
        setStep(state, action) {
            state.status = action.payload;
        },
    },
});

export const { setStep } = stepSlice.actions;
export default stepSlice.reducer;
